var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6541 16.9796L14.9762 13.3002C17.7282 9.62263 16.9778 4.41042 13.3002 1.65845C9.62263 -1.09351 4.41042 -0.343143 1.65845 3.33444C-1.09351 7.01203 -0.343143 12.2242 3.33444 14.9762C6.28858 17.1868 10.346 17.1868 13.3002 14.9762L16.9796 18.6556C17.442 19.118 18.1917 19.118 18.654 18.6556C19.1164 18.1933 19.1164 17.4436 18.654 16.9812L18.6541 16.9796ZM8.34799 14.266C5.07953 14.266 2.42994 11.6165 2.42994 8.34799C2.42994 5.07953 5.07953 2.42994 8.34799 2.42994C11.6165 2.42994 14.266 5.07953 14.266 8.34799C14.2626 11.615 11.615 14.2626 8.34799 14.266Z",
    fill: "#A2A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b78c01e5d9137252b5bddfdddcad44b4.svg";
export { ForwardRef as ReactComponent };